export default {"src":"/_next/static/media/consent_location.b2072bd8.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};